/** @format */

import { ipConstants } from './actions';

export function ipReducers(state = {}, action) {
    switch (action.type) {
        case ipConstants.LIST_POOL:
        case ipConstants.LIST_POOL_NUMBERS:
        case ipConstants.LIST_POOL_NAME_SELECT:
        case ipConstants.LIST_POOL_NUMBERS_CHOOSE:
            return {
                type: action.type,
                collections: action.collections,
            };
        case ipConstants.LIST_POOL_ITEM_LIST:
        case ipConstants.LIST_POOL_ITEM:
        case ipConstants.LIST_POOL_EDIT:
            return {
                type: action.type,
                item: action.item,
            };
        case ipConstants.LIST_POOL_ADD_NEW:
        case ipConstants.LIST_POOL_EDIT_SAVE:
            return {
                type: action.type,
                success: true,
            };
        case ipConstants.LIST_POOL_DELETE:
            return {
                type: action.type,
                success: false,
                rows: null,
            };
        default:
            return {
                ...state,
                type: action.type,
            };
    }
}
